/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedFieldString } from './ParsedFieldString';
import {
    ParsedFieldStringFromJSON,
    ParsedFieldStringFromJSONTyped,
    ParsedFieldStringToJSON,
} from './ParsedFieldString';

/**
 * 
 * @export
 * @interface PartialSupplier
 */
export interface PartialSupplier {
    /**
     * 
     * @type {string}
     * @memberof PartialSupplier
     */
    id?: string;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialSupplier
     */
    clientReference?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialSupplier
     */
    fullName?: ParsedFieldString;
    /**
     * 
     * @type {ParsedFieldString}
     * @memberof PartialSupplier
     */
    abbreviatedName?: ParsedFieldString;
    /**
     * 
     * @type {boolean}
     * @memberof PartialSupplier
     */
    hasParseErrors?: boolean;
}

/**
 * Check if a given object implements the PartialSupplier interface.
 */
export function instanceOfPartialSupplier(value: object): value is PartialSupplier {
    return true;
}

export function PartialSupplierFromJSON(json: any): PartialSupplier {
    return PartialSupplierFromJSONTyped(json, false);
}

export function PartialSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartialSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'clientReference': json['clientReference'] == null ? undefined : ParsedFieldStringFromJSON(json['clientReference']),
        'fullName': json['fullName'] == null ? undefined : ParsedFieldStringFromJSON(json['fullName']),
        'abbreviatedName': json['abbreviatedName'] == null ? undefined : ParsedFieldStringFromJSON(json['abbreviatedName']),
        'hasParseErrors': json['hasParseErrors'] == null ? undefined : json['hasParseErrors'],
    };
}

export function PartialSupplierToJSON(value?: PartialSupplier | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'clientReference': ParsedFieldStringToJSON(value['clientReference']),
        'fullName': ParsedFieldStringToJSON(value['fullName']),
        'abbreviatedName': ParsedFieldStringToJSON(value['abbreviatedName']),
        'hasParseErrors': value['hasParseErrors'],
    };
}

